import React from "react";
import settingsImg from "../../Assets/Images/settings-preview.svg";
import placeHolderImg from "../../Assets/Images/placeholder.png";

const ImageWithTextPreview = ({
  image,
  title,
  text,
  updateOpenArrayState,
  sectionId,
}) => {
  const parse = require("html-react-parser");
  const handleClickSection = () => {
    updateOpenArrayState(sectionId);
  };
  return (
    <div className="containerImageWithText mt-3">
      <div className="imgWithTextImage">
        <img src={image ? image : placeHolderImg} />
      </div>
      <div className="imgWithTextText">
        <h1>{parse(title)}</h1>
        <h1>{parse(text)}</h1>
      </div>

      <div className="overlay2" onClick={handleClickSection}>
        <img src={settingsImg} />
      </div>
    </div>
  );
};

export default ImageWithTextPreview;
